import { Modal, Button, Container, Row, Col, Badge, Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'react-bootstrap';
import { OrdersMcfTableRow } from '../../common/common.table.interfaces';
import CopySvg from '../../common/components/svg/CopySvg';
import { useCallback, useMemo } from 'react';
import JSONPretty from 'react-json-pretty';
import { CUSTOM_JSON_THEME } from '../../common/common.constants';
import { notify } from '../../notify/notify';

interface WayfairMcfSearchModalProps {
  title: string
  row: OrdersMcfTableRow
  visible: boolean
  hideModal: any
}

export default function WayfairMcfSearchModal(props: WayfairMcfSearchModalProps){
  const handleCopyClicked = useCallback((content) => {
    const copy = async function(){
      if (!content) return

      await navigator.clipboard.writeText(content)
      notify('success', 'Copied content to clipboard!')
    }
    copy()
  }, [])

  const view = useMemo(() => {
    const {row} = props
    if(!row) return
    let color = 'warning'
    if(['rejected', 'unknown', 'cancelled'].includes(row.status)){
      color = 'danger'
    } else if(row.status === 'complete'){
      color = 'success'
    }
    return (
      <Modal show={props.visible} animation={false} onHide={props.hideModal} className='modal-xl'>
        <Modal.Header 
          closeButton
          style={{ 
            position: 'sticky', 
            top: -1, 
            zIndex: 1050, 
            backgroundColor: 'white', 
            borderBottom: '1px solid #ddd'
          }}
        >
          <Modal.Title>
            {props.title}
          </Modal.Title>
        </Modal.Header>
          
        <Modal.Body>
          <table className='shipwise-table'>
            <tbody>
              <tr style={{textAlign: 'center'}}>
                <td>
                  <span className='beacon-header'>{row.orderNumber}</span>
                </td>
                <td>
                  <span className='beacon-header'>
                    {row.fulfillmentOrderRequestId ?? 'NOT YET CREATED'}
                  </span>
                </td>
                <td>
                  <span className='beacon-header'><Badge bg={color}>{row.status.toUpperCase()}</Badge></span>
                </td>
                <td>
                  <span className='beacon-header'><Badge bg={color}>{row.wayfairStatus.toUpperCase()}</Badge></span>
                </td>
              </tr>
            </tbody>
          </table>
          <hr/>
          {row.errors &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='create-request'>
                <AccordionHeader>ERRORS</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.errors)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.errors} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
          {row.createFulfillmentOrderInput &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='create-request'>
                <AccordionHeader>CREATE REQUEST</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.createFulfillmentOrderResponse)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.createFulfillmentOrderInput} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
          {row.createFulfillmentOrderResponse &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='create-response'>
                <AccordionHeader>CREATE RESPONSE</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.createFulfillmentOrderResponse)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.createFulfillmentOrderResponse} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
          {row.fulfillmentOrderDetailsInput &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='status-request'>
                <AccordionHeader>STATUS REQUEST</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.fulfillmentOrderDetailsInput)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.fulfillmentOrderDetailsInput} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
          {row.fulfillmentOrderDetailsResponse &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='status-response'>
                <AccordionHeader>STATUS RESPONSE</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.fulfillmentOrderDetailsResponse)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.fulfillmentOrderDetailsResponse} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
          {row.warehouseShippingAdviceResponse &&
            <Accordion className='custom-accordion'>
              <AccordionItem eventKey='status-response'>
                <AccordionHeader>TRACKING RESPONSE</AccordionHeader>
                <AccordionBody>
                  <span style={{cursor: 'pointer'}} title='Copy content to clipboard' onClick={() => {handleCopyClicked(row.warehouseShippingAdviceResponse)}}>
                    <CopySvg height={16} />
                  </span>
                  <JSONPretty data={row.warehouseShippingAdviceResponse} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.2em'}} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={props.hideModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }, [props])

  return view
}